module.exports = __webpack_public_path__ + "static/media/monopoly-video-cover.e2b8b3b5.png";